import { AxiosResponse } from 'axios'

import { WellnessCheckInRequestData, WellnessCheckInResponse } from '@lyrahealth-inc/shared-app-logic'

import { axiosInstance } from '../../../common/http/axiosInstance'

export type WellnessCheckInRequestV2Data = {
  token: string
}

export const getWellnessCheckInResults = (lyraId: string): Promise<AxiosResponse<WellnessCheckInResponse[]>> => {
  return axiosInstance.get<WellnessCheckInResponse[]>(`/v1/wellness-check-in/${lyraId}/results`)
}

export const postWellnessCheckInResults = (
  lyraId: string,
  requestBody: WellnessCheckInRequestData,
): Promise<AxiosResponse<WellnessCheckInResponse>> => {
  return axiosInstance.post<WellnessCheckInResponse>(`/v1/wellness-check-in/${lyraId}/results`, requestBody)
}

export const postWellnessCheckInResultsV2 = (
  lyraId: string,
  requestBody: WellnessCheckInRequestV2Data,
): Promise<AxiosResponse<WellnessCheckInResponse>> => {
  return axiosInstance.post<WellnessCheckInResponse>(`/v2/wellness-check-in/${lyraId}/results`, requestBody)
}
